import { FlowStepEditor } from "../FlowStepEditor";
import { FlowExecutionData } from "../../../rule-engine-core/Flow/Engine/FlowExecutionData";
import React from "react";
import { SaveFlowData } from "../../../rule-engine-core/Flow/Steps/General/SaveFlowData";

export class SaveFlowDataEditor extends FlowStepEditor<SaveFlowData> {
    renderEditUI(): JSX.Element | null {
        return <div>run flow</div>;
    }

    // eslint-disable-next-line
    start(thread: string, data: FlowExecutionData): void {}
}
